import { useMutation } from '@tanstack/react-query';
import { getAppConfiguration } from '@utils/browserEnv';
import { message } from 'antd';
import axios from 'axios';
import { useAccessToken } from 'services';

const { cmsFullApiUrl } = getAppConfiguration();

export default function useRemoveFavoriteBoat() {
  const { data: accessToken } = useAccessToken();

  const { isPending: isLoadingRemove, mutate: removeFavoriteFn } = useMutation({
    mutationFn: (id: number) =>
      axios({
        method: 'PUT',
        url: `${cmsFullApiUrl}/user-favorite-boat/remove-from-favorite`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: accessToken,
        },
        data: {
          boatId: id,
        },
      }),
    onSuccess: () => {
      message.info('Unfavourited boat successfully', 2);
    },
    onError: () => {
      message.error('Unfavourite boat error', 2);
    },
  });

  return {
    isLoadingRemove,
    removeFavoriteFn,
  };
}
